import { Box } from "@material-ui/core";
import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
} from "react";
import TableFilters from "views/SMS/MySMS/TableFilters";
import { getOrganisationId, getUserId } from "lib/utils/common_utils";
import { ToastMessageContext } from "lib/contexts/message_context";
import useGetReportsTableData from "../useGetReportsTableData";
import AllReportsTable from "./AllReportsTable";
import useGetFilterOptions from "../useGetFilterOptions";
import ReportsAction from "../ReportsAction";
import ReportsServices from "lib/services/api/reports/reports";

const AllReports = forwardRef((props, ref) => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const message = useContext(ToastMessageContext);

  const [openAction, setOpenAction] = useState({
    isOpen: false,
    currentSelection: null,
  });

  const [filterValues, setFilterValues] = useState({
    category_id: "",
  });

  const handleSearchTextChange = (value) => {
    setPage(0);
    setSearchText(value);
  };

  const handleFilterChange = (filterId, event) => {
    setFilterValues((prev) => {
      return { ...prev, [filterId]: event.target.value };
    });
  };

  const filterOptions = useGetFilterOptions();
  const { loading, totalCount, tableData, refetch } = useGetReportsTableData(
    filterValues,
    searchText,
    page,
    pageSize,
    "allReports"
  );

  const filtersList = [
    {
      name: "category_id",
      options: [
        { id: "", value: "Category (All)" },
        ...(filterOptions?.categories || []),
      ],
    },
  ];
  useImperativeHandle(ref, () => ({ refetch }));

  const handleOpenAction = (selected) => {
    if (!selected) return;
    setOpenAction({ isOpen: true, currentSelection: selected });
  };

  const handleCloseActions = () => {
    setOpenAction({ isOpen: false, currentSelection: null });
  };

  const handleFavouriteChange = async (selectedRow) => {
    setIsSubmitting(true);

    try {
      const payload = {
        user_id: getUserId(),
        organisation_id: getOrganisationId(),
        report_id: selectedRow?.id,
      };
      const response = await ReportsServices.toggleFavourite(payload);
      if (response.success) {
        message.showToastMessage({
          message: "Favourites updated succesfully",
          variant: "success",
        });
        refetch();
        setIsSubmitting(false);
      } else {
        throw new Error(response?.error);
      }
    } catch (error) {
      setIsSubmitting(false);
      message.showToastMessage({
        message:
          error?.message || "Something went wrong while submitting the form.",
        variant: "error",
      });
    }
  };

  const handleChangeFavourite = (selected) => {
    if (!selected) return;
    handleFavouriteChange(selected);
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      style={{ gap: "1rem", padding: "0rem 2rem" }}>
      <TableFilters
        handleFilterChange={handleFilterChange}
        searchText={searchText}
        filterValues={filterValues}
        handleSearchTextChange={handleSearchTextChange}
        filtersList={filtersList}
      />

      <AllReportsTable
        setPage={setPage}
        page={page}
        setPageSize={setPageSize}
        pageSize={pageSize}
        totalCount={totalCount}
        tableData={tableData}
        loading={loading || isSubmitting}
        handleOpenAction={handleOpenAction}
        handleChangeFavourite={handleChangeFavourite}
      />

      {openAction.isOpen && openAction.currentSelection ? (
        <ReportsAction
          handleCloseAction={handleCloseActions}
          currentSelection={openAction.currentSelection}
          refreshListing={refetch}
        />
      ) : null}
    </Box>
  );
});

export default AllReports;
